<ng-container *ngIf="shouldRender">
  <div *ngIf="isTableLocked" class="lock-message">
    Please submit the workflow or cancel them to delete the records.
  </div>

  <div *ngIf="showlastTables" class="workflow-step-title">
    2.Calculate Sales & Impact
  </div>
  <h3 class="component-main-title">{{ title }}</h3>
  <ng-container *ngIf="!loading; else loader">
    <div *ngFor="let table of multipleTables; let i = index" class="table-wrapper" [class.locked]="isTableLocked">
      <div class="file-name-display">
        <h3>{{ table.fileName }}</h3>
        <button *ngIf="!isEditable" mat-icon-button (click)="refreshTable()" matTooltip="Refresh Table">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="table-container">
        <div class="table-horizontal-wrapper">
          <table class="custom-table" [class.quote-parts-table]="data?.widgetId === 'quotePartsTable'">
            <thead class="table-header">
              <tr>
                <!-- Normal columns from data -->
                <th *ngFor="let col of table.columns" [attr.data-column]="col">{{ getColumnHeaderLabel(col) }}</th>

                <!-- Extra column header - only in editable tables -->
                <th *ngIf="isEditable && ExtraDropdown && !table.isResultTable && !table.isError">
                  Organization
                </th>
              </tr>
            </thead>

            <tbody>
               <tr *ngFor="let row of table.tableData">
                <!-- Normal editable / view cells -->
                <td
                  *ngFor="let col of table.columns"
                  [attr.data-column]="col"
                  [style.white-space]="col === 'item_id' ? 'nowrap' : null"
                  [style.overflow-wrap]="col === 'item_id' ? 'normal' : null"
                  [style.word-break]="col === 'item_id' ? 'keep-all' : null"
                >
                  <ng-container *ngIf="isEditable && !table.isError; else viewMode">
                    <ng-container *ngIf="isColumnDropdown(col); else inputCell">
                      <mat-form-field appearance="outline" class="table-input-select">
                        <mat-select
                          [(ngModel)]="row[col]"
                          [placeholder]="getDropdownPlaceholder(col)"
                          (selectionChange)="onCellDropdownChange(row, col, $event.value)"
                          [disabled]="dropdownLoadingMap[col]"
                        >
                          <mat-option *ngFor="let option of getColumnDropdownOptions(col)" [value]="option.value">
                            {{ option.label }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #inputCell>
                      <input type="text" class="table-input" [value]="row[col]" (input)="onCellEdit(row, col, $event)" />
                    </ng-template>
                  </ng-container>
                  <ng-template #viewMode>
                    <a *ngIf="col === 'error_stack' && row[col] && row[col] !== 'No Error'"
                      (click)="showError(row[col])" class="error-link">Error</a>
                    <div *ngIf="col !== 'error_stack' || !row[col] || row[col] === 'No Error'" class="view-mode-cell"
                      [class.error-message]="table.isError"
                      [style.white-space]="col === 'item_id' ? 'nowrap' : null"
                      [style.overflow-wrap]="col === 'item_id' ? 'normal' : null"
                      [style.word-break]="col === 'item_id' ? 'keep-all' : null"
                      [style.text-overflow]="col === 'item_id' ? 'ellipsis' : null"
                      [style.overflow]="col === 'item_id' ? 'hidden' : null">
                      {{ row[col] }}
                    </div>
                  </ng-template>
                </td>

                <!-- Organization dropdown column - only in editable tables -->
                <td *ngIf="isEditable && ExtraDropdown && !table.isResultTable && !table.isError"
                  class="organization-cell">
                  <mat-form-field appearance="outline" class="organization-select">
                    <mat-select [(ngModel)]="row.organization"
                      (selectionChange)="row.organization = $event.value; isSubmitDisabled = false">
                      <mat-option value="Company A">Base</mat-option>
                      <mat-option value="Company B">Regional</mat-option>
                      <mat-option value="Company C">Subsidiary</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-actions" *ngIf="showAddButton">
        <button mat-icon-button class="add-row-btn" (click)="addRow(i)" matTooltip="Add a new row to this table">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <label class="optimize-title" *ngIf="optimizedPrices">Optimize (Priority)</label>
  <div class="component-actions" *ngIf="data?.actions?.length > 0">
    <ng-container *ngFor="let action of data.actions">
      <button style="background-color: #366FFB; color: aliceblue; border-radius: 5px;"
        *ngIf="isActionVisible(action) && (action.label !== 'Submit' || hasInputTable)" mat-raised-button
        class="action-button" [style.margin-top]="margin_top" [ngClass]="{
          'btn-cancel': action.label === 'Cancel',
          'btn-grey': action.label === 'Upload' || action.label === 'Add Record',
          'btn-submit': action.label === 'Submit',
          'action-button-black': !['Cancel', 'Upload', 'Add Record', 'Submit'].includes(action.label)
        }" (click)="handleAction(action)"
        [disabled]="(action.label === 'Submit' && isSubmitDisabled) || (action.label === 'Add Record' && isAddRecordDisabled)">
        {{ action.label_name }}
      </button>
    </ng-container>
  </div>

  <ng-template #loader>
    <p class="loading-text">Loading table...</p>
  </ng-template>
</ng-container>

<!-- <label class="rationalize-label">Optimize (Define Priority)</label> -->
<div *ngIf="showRationalizeDropdown" class="rationalize-select-wrap">

  <label class="priority-title">Priority</label>
  <mat-form-field style="margin-right: 195px;" appearance="outline" class="rationalize-mat-field">
    <mat-select multiple [(value)]="selectedRationalizeKeys" placeholder="Select Priorities">
      <mat-option value="size">Size</mat-option>
      <mat-option value="material">Material</mat-option>
      <mat-option value="type">Type</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div *ngIf="optimizedPrice" class="optimized-price-card">
  <div class="title">Optimized Price : {{ optimizedPrice }}</div>
  <!-- <div class="value">{{ optimizedPrice }}</div> -->
</div>

<div *ngIf="showlastTables" class="approval-section">
  <div class="approval-content">
    <span class="approval-label">3. Approval:</span> <span class="approval-text">Auto
      Approved for value USD &lt; 1 Million</span>
  </div>
  <!-- <div class="value">{{ optimizedPrice }}</div> -->
</div>
<label *ngIf="showlastTables" class="attach-terms-label">
  <input type="checkbox" id="checkbox1" name="checkbox1" value="Option1" class="attach-terms-checkbox">
  Attach T&C
</label>



<div style="margin-top: 18px; margin-left: -10px;">
  <button *ngIf="showlastTables"
    class="deal-tracker-link"
    [routerLink]="['/deal-performance-tracker']">
    4.Deal Performance Tracker
  </button>
</div>


<div style="margin-left: 73vw; margin-top: -53px;">
  <button *ngIf=" showlinks"
    class="ai-generated-btn"
    (click)="goToAIGeneratedPrice()">
    AI Generated Price
  </button>
</div>

<div style="margin-left: 68vw; margin-top: -53px;">
  <button *ngIf="showlastTables"
    class="ai-generated-btn"
    (click)="goToAIGeneratedPrice()">
    AI Generated Price
  </button>
</div>
